export default class PromiseUtility{
    private static genPromise(doFun, result?){
        let promise = new Promise(function(resolve, reject){
            doFun(function(err, data){
                if(err){
                    reject(err)
                }else{
                    resolve(data)
                }
            }, result)
        });
        return promise
    }

    private static getPromiseList(doFuns: Function[]): any[]{
        let list: any[] = []
        for (let index = 0; index < doFuns.length; index++) {
            const element = doFuns[index];            
            list.push(this.genPromise(element))
        }
        return list
    }

    static all(doFuns: Function[]){
        let promiseList = this.getPromiseList(doFuns)
        return Promise.all(promiseList)
    }

    static race(doFuns: Function[]){
        let promiseList = this.getPromiseList(doFuns)
        return Promise.race(promiseList)
    }

    static sequence(doFuns: Function[], param?){
        let p = null
        for (let index = 0; index < doFuns.length; index++) {
            const do_fun = doFuns[index];
            if(p == null){
                p = PromiseUtility.genPromise(do_fun, param)
            }else{
                p = p.then(function(result){
                    return PromiseUtility.genPromise(do_fun, result)
                })
            }                        
        }
        return p
    }

}